import { environment as base } from './environment';
import { apiUrls } from './api-urls';
import type { Environment } from './environment';

export const environment: Environment = {
  ...base,
  apiProxyUrl: 'https://api.uhg.com/api/pdr/msr/uhci-aws-core-api/v1.0.0/',
  ssoApiProxyUrl: 'https://uhci-ui-internal.optum.com/',
  postLoginProxyUrl: '/uhci/login/prod/',
  originUrl: '/',
  redirectUri: 'https://uhci-ui-internal.optum.com/',
  domain: '.uhc.com',
  domainEnvironment: ['https://uhcinsights-internal.uhc.com'],
  cookieEnvironment: '',
  featureFlagUrl: 'https://api.uhg.com/api/pdr/msr/uhci-aws-pnb-api/v1.0.0/pnb/feature-flags/',
  upstreamEnv: 'prod',
  goldCardEnvironment: 'prod',
  goldCardabyssparcelUrl: 'https://uhci-ui-internal.optum.com/abyss-parcel.js',
  qualtricksEnvCheck: 'prod',
  clickStreamUrl:
    'https://assets.adobedtm.com/512027f42d3c/c18a9fa8e51b/launch-EN62cebcdf8f9040658ffce30131f73259.min.js',
  production: true,
  staging: false,
  noPROD: false,
  goldCardFeatureToggle: 'true',
  qualtrics: true,
  isProdClaimsYieldToggleOff: true,
  apiUrls: {
    ...apiUrls,
    bulkTinRUrl: 'https://api.uhg.com/api/pdr/msr/uhci-aws-bulk-process-api/v1.0.0/',
    SsoRedirectUri:
      'https://sso.uhc.com/ext/as/authorization.oauth2?pfidpadapterid=OptumIdOIDCStage&client_id=PED42235&response_' +
      'type=code&redirect_uri=https://uhci-ui-internal.optum.com/login&scope=openid+profile+email&state=PED&prompt=none',
    SsoRedirectLogin:
      'https://identity.onehealthcareid.com/oidc/authorize?client_id=PED42235&response_type=code&' +
      'redirect_uri=https://uhci-ui-internal-prod.optum.com/login&scope=openid+profile+email&state=PED&prompt=login',
    SsoLogoutUrl:
      'https://api.linkhealth.com/session/signout?redirect=https://provider.linkhealth.com/' +
      'content/odin/en/provider-dashboard/public/signout.html?logOut=true',
    linkLoginPage: 'https://provider.linkhealth.com',
    providerLoginPage: 'https://secure.uhcprovider.com/',
  },
};
